import { MouseEvent } from 'react';

import { SkipLink } from 'approot/shared/layout/layout-skip-links.style';
import { ACTIVITY_BUILDER_GLOBAL_MENU_ID } from './activity-builder.constants';

export const ACTIVITY_BUILDER_SLIDE = 'slide';
export const ACTIVITY_BUILDER_SLIDE_NAVIGATION = 'slideNavigation';

const ActivityBuilderSkipLinks = () => {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    el?.focus();
  };

  return (
    <>
      <SkipLink
        href={`#${ACTIVITY_BUILDER_SLIDE}`}
        onClick={e => handleClick(e, ACTIVITY_BUILDER_SLIDE)}
      >
        <span>Skip to slide</span>
      </SkipLink>
      <SkipLink
        href={`#${ACTIVITY_BUILDER_SLIDE_NAVIGATION}`}
        onClick={e => handleClick(e, ACTIVITY_BUILDER_SLIDE_NAVIGATION)}
      >
        <span>Skip to slide navigation</span>
      </SkipLink>
      <SkipLink
        href={`#${ACTIVITY_BUILDER_GLOBAL_MENU_ID}`}
        onClick={e => handleClick(e, ACTIVITY_BUILDER_GLOBAL_MENU_ID)}
      >
        <span>Skip to slide controls</span>
      </SkipLink>
    </>
  );
};

export default ActivityBuilderSkipLinks;
